import { render, staticRenderFns } from "./BtJsonViewer.vue?vue&type=template&id=b1b403c0&"
import script from "./BtJsonViewer.vue?vue&type=script&lang=js&"
export * from "./BtJsonViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports